import type * as React from "react";

import { faArrowRightFromBracket } from "@performyard/fontawesome/pro-light-svg-icons";
import type { SideNavUserMenuOption } from "@performyard/py-components";

import type { NavigationConfig } from "../../api/services/defs/navigation";

import { resetPostHog } from "./posthogReset";

const openBeacon = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
	event.preventDefault();
	if (typeof window !== "undefined" && window.Beacon) {
		window.Beacon("open");
	}
};

/** Single source of truth for the SideNav footer + TopBar avatar menus. */
export const buildUserMenuOptions = (config: NavigationConfig): SideNavUserMenuOption[] => {
	const options: SideNavUserMenuOption[] = [];
	if (config.possessor) {
		options.push({
			id: "unpossess",
			label: `Return to ${config.possessor.name}`,
			href: "/unpossess/",
			onClick: () => resetPostHog(),
		});
	}
	if (config.isOverlord) {
		options.push({ id: "super-user", label: "Super User", href: "/super-user/" });
	}
	options.push({
		id: "employee-details",
		label: "Employee Details",
		href: `/details/${config.currentUserId}/`,
	});
	options.push({
		id: "settings",
		label: "Settings",
		href: config.isEngagementOnly ? "/settings/account/" : "/settings/notifications/",
	});
	options.push({ id: "help", label: "Get Help", onClick: openBeacon });
	options.push({
		id: "support",
		label: "Support",
		href: "http://support.performyard.com",
		isExternal: true,
	});
	options.push({
		id: "logout",
		label: `Logout, ${config.currentUserName}`,
		href: "/logout/",
		// FA 6.7 has no arrow-left-from-bracket; mirror the right-facing one.
		icon: faArrowRightFromBracket,
		iconClassName: "-scale-x-100",
		divider: "before",
	});
	return options;
};
